import React from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';

import colors from '../../../../../../../../styles/theme/foundation/colors';
import underConstructionImage from '../../../../../../../../under-construction.png';

function TemplateBuilderItemPanel() {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      px={5}
      py={4}
    >
      <Image height="auto" src={underConstructionImage} width="250px" />
      <Text color={colors.greyScale['500']} py="2rem" textStyle="bodyLg500">
        Item Templates Coming Soon!
      </Text>
    </Flex>
  );
}

export default TemplateBuilderItemPanel;
